import { Box, Flex, Text as CText } from "@chakra-ui/react";
import { Link } from "react-router-dom";

// TODO: Issue MRP-2775
// eslint-disable-next-line import/no-unresolved
import { ArrowRight } from "ui-kit/icon";

/* Referral program card for the side nav, behind referralrock.direct_add. Mirrors the
   "Referral Program Card" design: white surface, teal pill, outlined dollar circles and a
   cyan CTA. Type and spacing are scaled down from the design's 440px canvas to fit the
   300px nav column. The CTA links to /refer-a-friend rather than copying a link inline —
   the referral link lives on that page now. */

const DollarCircle = () => (
  <Flex
    align="center"
    justify="center"
    w="22px"
    h="22px"
    borderRadius="full"
    border="1.5px solid #3CBFC5"
    flexShrink={0}
  >
    <CText fontSize="10px" fontWeight="700" color="#3CBFC5" mt="1px" mb="0">
      $
    </CText>
  </Flex>
);

const ReferralProgramCard = () => (
  <Flex
    flexDir="column"
    gap="3"
    m="3"
    p="5"
    bg="white"
    border="1px solid rgba(13, 61, 79, 0.1)"
    borderRadius="16px"
    boxShadow="0 6px 24px rgba(13, 61, 79, 0.07)"
  >
    <Flex align="center" justify="space-between" gap="2">
      <Box
        bg="#0D3D4F"
        color="white"
        fontFamily="headingMedium"
        fontSize="10px"
        fontWeight="600"
        letterSpacing="0.14em"
        textTransform="uppercase"
        px="3"
        py="1.5"
        borderRadius="full"
        whiteSpace="nowrap"
      >
        Referral Program
      </Box>
      <Flex gap="1" flexShrink={0}>
        <DollarCircle />
        <DollarCircle />
        <DollarCircle />
      </Flex>
    </Flex>

    <Box>
      <CText fontFamily="heading" fontSize="17px" lineHeight="1.25" color="#0D3D4F" mb="0">
        Help another retailer and get $100!
      </CText>
      <CText fontSize="13px" lineHeight="1.55" color="#4A5568" mt="2" mb="0">
        Know someone sitting on inventory? Invite them. They join, you get paid.
      </CText>
    </Box>

    <Flex
      as={Link}
      to="/refer-a-friend"
      align="center"
      justify="center"
      gap="2"
      w="full"
      py="3"
      bg="#3CBFC5"
      color="#00252F"
      fontFamily="headingMedium"
      fontSize="14px"
      fontWeight="600"
      borderRadius="full"
      boxShadow="0 8px 24px rgba(60, 191, 197, 0.28)"
      transition="background 220ms cubic-bezier(0.22, 1, 0.36, 1), transform 140ms cubic-bezier(0.22, 1, 0.36, 1)"
      _hover={{ bg: "#7DD8DC", transform: "translateY(-1px)", textDecoration: "none" }}
      _active={{ transform: "scale(0.985)" }}
      data-testid="side-nav-referral-card-cta"
    >
      Refer a friend
      <Box as={ArrowRight} width="7.5px" height="6.43px" />
    </Flex>
  </Flex>
);

export default ReferralProgramCard;
